import {
  fetchAiDataIntelligencePage,
  fetchFinTechPage,
  fetchHealthcareIndustryPage,
  fetchHighTechSoftwarePage,
  fetchMobilityPage,
  fetchRealEstateConstructionPage,
  fetchRetailEcommercePage,
  fetchTelecomMediaPage,
  fetchTravelHospitalityPage,
} from "../services/contentApi";
import { IndustryPageProvider } from "./IndustryPageContext";

export function MobilityPageProvider({ children }) {
  return (
    <IndustryPageProvider fetchPage={fetchMobilityPage}>{children}</IndustryPageProvider>
  );
}

export function HealthcareIndustryPageProvider({ children }) {
  return (
    <IndustryPageProvider fetchPage={fetchHealthcareIndustryPage}>
      {children}
    </IndustryPageProvider>
  );
}

export function RetailEcommercePageProvider({ children }) {
  return (
    <IndustryPageProvider fetchPage={fetchRetailEcommercePage}>
      {children}
    </IndustryPageProvider>
  );
}

export function FinTechPageProvider({ children }) {
  return (
    <IndustryPageProvider fetchPage={fetchFinTechPage}>{children}</IndustryPageProvider>
  );
}

export function TravelHospitalityPageProvider({ children }) {
  return (
    <IndustryPageProvider fetchPage={fetchTravelHospitalityPage}>
      {children}
    </IndustryPageProvider>
  );
}

export function HighTechSoftwarePageProvider({ children }) {
  return (
    <IndustryPageProvider fetchPage={fetchHighTechSoftwarePage}>
      {children}
    </IndustryPageProvider>
  );
}

export function TelecomMediaPageProvider({ children }) {
  return (
    <IndustryPageProvider fetchPage={fetchTelecomMediaPage}>
      {children}
    </IndustryPageProvider>
  );
}

export function RealEstateConstructionPageProvider({ children }) {
  return (
    <IndustryPageProvider fetchPage={fetchRealEstateConstructionPage}>
      {children}
    </IndustryPageProvider>
  );
}

export function AiDataIntelligencePageProvider({ children }) {
  return (
    <IndustryPageProvider fetchPage={fetchAiDataIntelligencePage}>
      {children}
    </IndustryPageProvider>
  );
}
